<script setup lang="ts">
defineProps<{
  visible: boolean
  title?: string
  description?: string
  errors: string[]
}>()

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
}>()

function handleClose() {
  emit('update:visible', false)
}
</script>

<template>
  <a-modal
    :visible="visible"
    :title="title || 'Some data could not be retrieved'"
    :footer="null"
    centered
    width="500px"
    @cancel="handleClose"
  >
    <p class="text-gray-600 mb-4">
      {{ description || 'The following issues were encountered.' }}
    </p>
    <div class="space-y-2 max-h-[300px] overflow-y-auto">
      <div
        v-for="(error, index) in errors"
        :key="index"
        class="p-3 bg-red-50 border border-red-200 rounded-md text-base text-red-600"
      >
        {{ error }}
      </div>
    </div>
  </a-modal>
</template>
